import { useState, useEffect } from 'react';
import { _getLeadsRelated } from 'controllers/leads/leads_controller';

export function useRelatedLeads(schoolId, leadId, shouldFetch = false) {
  const [relatedLeads, setRelatedLeads] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchRelatedLeads = async () => {
    if (!shouldFetch) return;

    setLoading(true);
    setError(null);
    try {
      const res = await _getLeadsRelated(schoolId, leadId);
      setRelatedLeads(res);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (shouldFetch) {
      fetchRelatedLeads();
    }
  }, [schoolId, leadId, shouldFetch]);

  return { relatedLeads, loading, error };
}
